module.exports = __webpack_public_path__ + "static/media/testimonial-camille-nl.eb227c30.webp";